import apiClient from "./axios"

// -------------------- MODULES --------------------
export const getModules = async (params = {}) => {
  const { data } = await apiClient.get("/role-permission/modules", { params })
  return data
}

export const getModule = async id => {
  const { data } = await apiClient.get(`/role-permission/modules/${id}`)
  return data
}

// -------------------- PERMISSIONS --------------------
export const getPermissions = async (params = {}) => {
  const { data } = await apiClient.get("/role-permission/permissions", {
    params,
  })
  return data
}

export const getPermission = async id => {
  const { data } = await apiClient.get(`/role-permission/permissions/${id}`)
  return data
}

// -------------------- ROLES --------------------
export const getRoles = async (params = {}) => {
  const { data } = await apiClient.get("/role-permission/roles", { params })
  return data
}

export const getRole = async id => {
  const { data } = await apiClient.get(`/role-permission/roles/${id}`)
  return data
}

export const createRole = async roleData => {
  const { data } = await apiClient.post("/role-permission/roles", roleData)
  return data
}

export const editRole = async ({ id, ...roleData }) => {
  const { data } = await apiClient.put(`/role-permission/roles/${id}`, roleData)
  return data
}

export const deleteRole = async id => {
  const { data } = await apiClient.delete(`/role-permission/roles/${id}`)
  return data
}

// -------------------- USER ROLES --------------------
export const getUserRoles = async (userId, params = {}) => {
  const { data } = await apiClient.get(
    `/role-permission/users/${userId}/roles`,
    { params }
  )
  return data
}

// -------------------- ROLE-PERMISSIONS --------------------

// Get all permissions of a role
export const getRolePermissions = async (roleId, params = {}) => {
  const { data } = await apiClient.get(
    `/role-permission/roles/${roleId}/permissions`,
    { params }
  )
  return data
}

// Assign permissions to a role
export const assignPermissionsToRole = async (roleId, permissionIds) => {
  const { data } = await apiClient.post(
    `/role-permission/roles/${roleId}/permissions`,
    {
      permissionIds,
    }
  )
  return data
}

